import { Api } from '../api';
import { rewards } from '../endpoints';
import type { ApiResponse } from '@shared/api';
import type { GetBalanceResponse, GetRewardsTransactionsRequest, GetRewardsTransactionsResponse } from './models';

export class RewardsApi extends Api {
  static getBalance = (signal?: AbortSignal) => this.get<ApiResponse<GetBalanceResponse>>({ url: rewards.getBalance(), signal });

  static getTransactions = (request: GetRewardsTransactionsRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<GetRewardsTransactionsResponse>>({ url: rewards.getTransactions(), queryParams: request, signal });
}
